import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from '../../../dashboard/rfq-cache.service';
import {
  AbstractControl,
  FormBuilder,
  FormArray,
  FormControl,
  FormGroup,
  NgForm,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import {
  aboutDataType,
  AutoCompleteDataType,
  AutoCompleteSupplierProduct,
  Currency,
  quoteAttachmentType,
  quoteDeclineReasonType,
  incoterms,
  offeredQuality,
  portData,
  supplierBranchData,
  Vessel,
} from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService } from '../../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from 'uuid';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { MatRadioChange } from '@angular/material/radio';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { PurchaseOrderService } from '../purchase-order.service';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { UserManagementService } from 'src/app/views/userManagement/userManagement.service';
import { SuppliersComponent } from 'src/app/views/settings/suppliers/suppliers.component';

interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}

interface Countries {
  name: string;
  code: string;
  dialcode: string;
  currency: string;
  flag: string;
}

interface Location {
  locationId: number;
  locationName: string;
  code: string;
}

interface Incoterm {
  incotermId: number;
  incotermCode: string;
  userId: number;
  locationDetails: Location[];
}

@Component({
  selector: 'app-purchase-order-preview',
  templateUrl: './purchase-order-preview.component.html',
  styleUrls: ['./purchase-order-preview.component.css'],
})
export class PurchaseOrderPreviewComponent implements OnInit {
  @ViewChild('table') table!: DatatableComponent;
  @ViewChild('pdfContent') contentToPrint!: ElementRef<HTMLDivElement>;
  rfqId!: number;
  quoteId!: number;
  purchaseOrderId!: number;
  isSaved: boolean = false;
  currentTab: string = 'preview';
  tabEnabled: boolean = false;
  supplierId!: any;
  incotermLocations: string = '';
  buyerLogo: string = '';
  supplierLogo: string = '';
  incotermsCode: number | null = null;
  showConfirmationDialogue: boolean = false;
  showSuccessDialogue: boolean = false;
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs: any[] = [];
  currentIndex = 0;

  headerResponse: any;
  portAgencyAndFreightAndBillingResponse:any;

  selectedApprovalId!:number;
  isApprovalRequired:boolean=false;
  isApprovalSent:boolean=false;

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: 'directions_boat',
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: 'looks',
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: 'location_searching',
      route: 'payment-terms',
    },
    {
      index: 3,
      label: 'PREVIEW',
      icon: 'location_searching',
      route: 'preview',
    },
  ];

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';

  // Port Agent Validation
  isPortAgentMissing: boolean = false;

  secondFormGroup!: UntypedFormGroup;
  declineFormGroup!: UntypedFormGroup;
  lineItemtableForm!: any;
  row: any = [];
  dataSource: any[] = [];
  headerData: any;
  showDeclineConfirmationDialogue: boolean = false;
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;

  showAddDocumentSection: boolean = false;
  showAddCostSection: boolean = false;
  showDeclineSection: boolean = false;

  showOtherReason: boolean = false;
  showHazardousDeclaration: boolean = false;

  displayedColumns = [
    'position',
    'partNumber',
    'supplierPartNumber',
    'itemDescription',
    'buyerComment',
    'supplierComment',
    'customsCode',
    'uom',
    'quantity',
    'supplierUom',
    'supplierQuantity',
    'unitCost',
    'requestedUnitCost',
    'discount',
    'totalCost',
    'requestedTotalCost',
    'leadTime',
    'attachments',
    'delete',
  ];

  groupHeadersColumns = [
    'checkboxGroup',
    'positionGroup',
    'partNumberGroup',
    'supplierPartNumberGroup',
    'itemDescriptionGroup',
    'buyerCommentGroup',
    'supplierCommentGroup',
    'customsCodeGroup',
    'attachmentsGroup',
    'uomQuantityGroup',
    'supplierUomQuantityGroup',
    'unitCostGroup',
    'discountGroup',
    'totalCostGroup',
    'leadTimeGroup',
    'deleteGroup',
  ];

  lineItemAttachmentTypeData: quoteAttachmentType[] = [];
  delineReasonData: quoteDeclineReasonType[] = [];

  selectedLineItemIndex!: number | null;

  declineReason!: number | null;
  otherReason: string = '';

  freightDescription: string = '';
  freightType: string = 'amount';
  freightValue!: number | null;
  addedAdditionalCost: any[] = [];

  selectedAttachmentType!: number | null;
  hazardousDeclaration!: number | null;
  newfileuploaded: boolean = false;
  uploadedAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB

  currentdate = new Date();
  taxStatusData: any[] = [];
  tableWidth = '100%';
  dynamicColumns = [
    // { key: 'buyerComment', name: 'Buyer Comment', visible: false },
    // { key: 'supplierComment', name: 'Supplier Comment', visible: false },
    // { key: 'customsCode', name: 'Customs Code', visible: false },
    // { key: 'quantity', name: 'Requested Quantity', visible: false },
    // { key: 'uom', name: 'Requested UOM', visible: false },
    // { key: 'unitCost', name: 'Unit Cost', visible: false },
    // { key: 'discount', name: 'Discount', visible: false },
    // { key: 'totalCost', name: 'Total Cost', visible: false },
    // { key: 'leadTime', name: 'Lead Time', visible: false },
    // { key: 'supplierUom', name: 'Supplier UOM', visible: false },
    // { key: 'supplierQuantity', name: 'Supplier Quantity', visible: false },
    { key: 'attachments', name: 'Attachments', visible: false },
    { key: 'requestedUnitCost', name: 'Requested Unit Cost', visible: false },
    { key: 'requestedTotalCost', name: 'Requested Total Cost', visible: false },
    // { key: 'delete', name: 'Delete', visible: false },
  ];

  firstFormGroup!: UntypedFormGroup;

  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;
  isForm4Expand: boolean = true;
  isForm5Expand: boolean = true;
  isForm6Expand: boolean = true;
  isForm7Expand: boolean = true;
  isForm8Expand: boolean = true;

  isForm9Expand: boolean = true;
  isForm10Expand: boolean = true;
  isForm11Expand: boolean = true;
  isForm12Expand: boolean = true;

  lastId!: number;
  headerAttachmentUrl: any;
  headerAttachmentSection: boolean = false;
  paymentTermsAndConditionsSection: boolean = false;
  buyerAttachmentsSection: boolean = false;
  paymentTermsAndConditions: any;
  paymentTermsAndConditionAttachmentUrl: any;
  buyerAttachmentUrl: string[] = [];
  incoterms: incoterms[] = [];
  offeredQualityData: offeredQuality[] = [];
  headerAttachmentType: quoteAttachmentType[] = [];
  lineItemAttachmentType: quoteAttachmentType[] = [];

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  boundGetCountryAutoComplete!: (pageMeta: Page) => Observable<any>;

  searchKeyParams: string = '';
  delAttachmentArr: number[] = [];

  countryControl: FormControl = new FormControl();
  // countries: Countries[] = [];
  countries: any[] = [];
  filteredCountries: any[] = [];
  selectedCountries: any[] = [];
  incotermLocationList: any[] = [];

  paymentFormGroup!: UntypedFormGroup;
  buyerFormGroup!: UntypedFormGroup;

  buyerStreet: any;
  buyerCity: any;
  buyerZipCode: any;
  buyerStateCode: any;
  buyerCountry: any;

  selectedTermsConditionIndex!: number | null;
  previewDoc: any[] = [];
  uploadedAdditionalAttachmentsArray: any[] = [];

  approvalData:any[] = [];

  filterFieldCountryNameDisplayFn(_country: AutoCompleteDataType) {
    return _country ? `${_country.name}` : undefined;
  }
  showColumn(col: { key: string; name: string; visible: boolean }) {
    col.visible = !col.visible;
    // this.tableWidth = 'max-content';
    // this.cdr.detectChanges();
    this.table.recalculate();
  }

  showToggleColumns(col: any) {
    col.visible = !col.visible;
    this.table.recalculate();
  }

  getColumn(key: string) {
    return this.dynamicColumns.find((c) => c.key === key);
  }

  boundGetSupplierProductAutoComplete!: (pageMeta: Page) => Observable<any>;

  reviewTooltip = `• Once the Purchase Order (PO) is sent, no further changes can be made.
  • Please review all details carefully before clicking the Send PO option.`;





  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService: RfqGenerateFormService,
    private cookieService: CookieService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private CookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private purchaseOrderService: PurchaseOrderService,
    private userManagementService: UserManagementService
  ) {
    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });
  }

  // Rounds any numeric value to exactly 3 decimal places
  private round3(value: any): number {
    const n = Number(value) || 0;
    return Math.round((n + Number.EPSILON) * 1000) / 1000;
  }

  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.boundGetCurrencyAutoComplete =
      this.getCurrencyFilterKeyDataObservable.bind(this);

    this.boundGetSupplierProductAutoComplete =
      this.getSupplierProductFilterKeyDataObservable.bind(this);

    this.getTaxDetails();

    this.secondFormGroup = this._formBuilder.group({
      quoteLineItemHeaderId: [null],
      quoteLineItemListPriceSubtotal: [null],
      quoteLineItemDiscount: [null],
      quoteLineItemSubtotal: [null],
      quoteLineItemGeneralDiscountType: ['percentage'],
      quoteLineItemGeneralDiscountValue: [null],
      quoteLineItemFreightTotal: [null],
      quoteLineItemFreight: [null],
      quoteLineItemTotal: [null],
      supplierCurrency: [null],
      quoteLineItemApplicableTaxProfile: [null],
      quoteLineItemTaxAmount: [null],
    });

    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });

    this.firstFormGroup = this._formBuilder.group({
      // Purchase Order Details
      purchaseOrderRefNumber: [''],
      purchaseOrderDate: [''],
      rfqRefNumber: [''],
      rfqDate: [''],
      quoteRefNumber: [''],
      quotationDate: [''],
      expectedDeliveryDate: [''],

      // Buyer Company Details
      buyerName: [''],
      buyerEmail: [''],
      buyerPhone: [''],
      buyerFax: [''],
      buyerAddress: [''],

      // Buyer Details
      buyerContactPerson: [''],
      buyerContactEmail: [''],
      buyerContactPhone: [''],
      buyerContactFax: [''],
      buyerContactAddress: [''],

      // Supplier Details
      supplierContactName: [''],
      supplierEmail: [''],
      supplierPhone: [''],
      supplierFax: [''],
      supplierCompanyEmail: [''],

      // Vessel Details
      vesselName: [''],
      vesselIMONumber: [''],
      vesselType: [''],
      vesselClass: [''],
      hullNumber: [''],
      yardName: [''],
      yearBuilt: [''],


      // Port Details
      portName: [''],
      portCode: [''],
      vesselETA: [''],
      vesselETD: [''],
      vesselETB: [''],
    });

    this.paymentFormGroup = this._formBuilder.group({
      // Buyer Payment Terms
      billingAddress: [''],
      applicableTaxProfile: [''],
      buyersPaymentTerms: [''],
      buyerTermsAndConditions: [''],

      // Port Agent Details
      portAgencyName: [''],
      portAgentName: [''],
      portAgentPhoneNumber: [''],
      portAgentContact: [''],
      portAgentPhoneFax: [''],
      portAgentEmail: [''],
      portAgentAddress: [''],

      // Terms and Conditions (file upload + text)
      termsAndConditions: [''],
      attachments: [null],

      // Freight Forwarder Details
      freightCompanyName: [''],
      freightPIC: [''],
      freightJobTitle: [''],
      freightEmail: [''],
      freightPhone: [''],
      freightFax: [''],
      freightAddress: [''],
      freightPackaging: [''],
      freightTransportMode: [''],
    });

    this.lineItemAttachmentTypeData =
      await this.quoteService.fetchAllQuteAttachmentType(
        'QuoteLineItemAttachmentType'
      );

    this.delineReasonData = await this.quoteService.fetchAllDeclineReason();

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);

    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (
        params['rfqId'] != '' &&
        params['quoteId'] != '' &&
        params['purchaseOrderId'] != ' '
      ) {
        this.rfqId = params['rfqId'];
        this.quoteId = params['quoteId'];
        this.purchaseOrderId = params['purchaseOrderId'];

        this.getQuoteDraftData();
        let param1 = {
          purchaseOrderId: this.purchaseOrderId,
          section: 'header',
        };
        const result1 = await this.purchaseOrderService.fetchPurchaseOrder(
          param1
        );
        const data = result1[0];
        this.headerResponse = data;
        this.supplierId = data.supplierId;
        this.buyerLogo = data.buyerOrganizationLogo || '';
        this.supplierLogo = data.supplierOrganizationLogo || '';
        this.incotermLocations = data.incotermLocations || '';
        this.incotermsCode = data.incoterms || null;
        console.log('result from header->', data);
        console.log('this.supplierId', this.supplierId);
        console.log('this.incotermsCode', this.incotermsCode);
        console.log('this.incotermLocations', this.incotermLocations);
        console.log('this.buyerLogo', this.buyerLogo);
        console.log('this.supplierLogo', this.supplierLogo);
        console.log('result form header', result1[0]);
        this.firstFormGroup.patchValue({
          // Purchase Order Details
          purchaseOrderRefNumber: data.purchaseOrderRefNumber || '',
          purchaseOrderDate: data.purchaseOrderDate || '',
          rfqRefNumber: data.rfqRefNumber || '',
          rfqDate: data.rfqDate || '',
          quoteRefNumber: data.quoteRefNumber || '',
          quotationDate: data.quotationDate || '',
          expectedDeliveryDate: data.expectedDeliveryDate || '',
            // ? new Date(
            //     new Date(data.onTimeDeliveryOrderBy).setDate(
            //       new Date(data.onTimeDeliveryOrderBy).getDate() +
            //         (Number(data.quotedDeliveryInDays) || 0)
            //     )
            //   )
            //     .toISOString()
            //     .split('T')[0]
            // : '',

          // Buyer Company Details
          buyerName: data.buyerCompanyName || '',
          buyerEmail: data.companyEmailId || '',
          buyerPhone: data.companyPhoneNumber || '',
          buyerFax: data.companyFax || '',
          buyerAddress: data.companyAddress || '',

          // Buyer Details
          buyerContactPerson: data.buyerContactPerson || '',
          buyerContactEmail: data.buyerEmail || '',
          buyerContactPhone: data.buyerPhone || '',
          buyerContactFax: data.buyerFax || '',
          buyerContactAddress: data.buyerAddress || '',

          // Supplier Details
          supplierContactName:
            data.supplierContactPerson || data.supplierFullName || '',
          supplierEmail: data.supplierEmail || '',
          supplierPhone: data.supplierPhone || '',
          supplierFax: data.supplierFax || '',
          supplierCompanyEmail:
            data.supplierCompanyEmail || data.supplierEmail || '',

          // Vessel Details
          vesselName: data.vesselName || '',
          vesselIMONumber: data.vesselImoNumber || '',
          vesselType: data.vesselType || '',
          vesselClass: data.class || '',
          hullNumber: data.hullNumber || '',
          yardName: data.yardName || '',
          yearBuilt: data.yearBuilt || '',

          // Port Details
          portName: data.portName || '',
          portCode: data.portCode || '',
          vesselETA: data.vesselEta || '',
          vesselETD: data.vesselEtd || '',
          vesselETB: data.vesselEtb || '',
        });

        this.isApprovalRequired = data.isApprovalRequired;

        console.log("isApprovalRequired",this.isApprovalRequired);

        
        if (this.isApprovalRequired && data.approvalStatus == 3) {
          this.isApprovalSent = true;
        }

        let param2 = {
          purchaseOrderId: this.purchaseOrderId,
          section: 'paymentTerms',
        };
        const result2 = await this.purchaseOrderService.fetchPurchaseOrder(
          param2
        );
        console.log({ result2 });
        const response = result2[0];
        this.portAgencyAndFreightAndBillingResponse=result2[0];
        // Update form values
        this.paymentFormGroup.patchValue({
          // billingAddress:
            // response.invoiceAddressType == 2 ? response.billingAddress : '',
            billingAddress: response.billingAddress,
          applicableTaxProfile: response.applicableTaxProfile,
          buyersPaymentTerms: response.buyersPaymentTerms,
          buyerTermsAndConditions: response.termsAndConditions,
          portAgencyName: response.portAgencyName,
          portAgentName: response.portAgentName,
          portAgentPhoneNumber: response.portAgentPhoneNumber,
          portAgentContact: response.portAgentContact,
          portAgentPhoneFax: response.portAgentPhoneFax,
          portAgentEmail: response.emailId,
          portAgentAddress: response.address,
          termsAndConditions: response.termsAndConditions,
          attachment: response.paymentTermsAttachments,
          freightCompanyName: response.freightCompanyName || '',
          freightPIC: response.freightPIC || '',
          freightJobTitle: response.freightJobTitle || '',
          freightEmail: response.freightEmail || '',
          freightPhone: response.freightPhone || '',
          freightFax: response.freightFax || '',
          freightAddress: response.freightAddress || '',

          // freightPackaging: Array.isArray(response.freightPackaging)
          //   ? response.freightPackaging
          //       .map((p: any) => p?.packagingType)
          //       .filter((v: any) => v)
          //       .join(', ')
          //   : (response.freightPackaging || ''),

          // freightTransportMode: Array.isArray(response.freightTransportMode)
          //   ? response.freightTransportMode
          //       .map((m: any) => m?.modeOfTransport)
          //       .filter((v: any) => v)
          //       .join(', ')
          //   : (response.freightTransportMode || ''),

          freightPackaging: this.formatFreightField(
            response.freightPackaging,
            'packagingType'
          ),

          freightTransportMode: this.formatFreightField(
            response.freightTransportMode,
            'modeOfTransport'
          ),
        });
        this.uploadedAdditionalAttachmentsArray =
          response.paymentTermsAttachments;

        // Check if Port Agent Details is filled
        this.isPortAgentMissing = !response.portAgentId;
      }
    });

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);
    this.fetchRfqDetails();

    this.checkisTabEnabled();
    await this.getApprovalData();
  }

  async getApprovalData() {
    this.fullLoaderService.showLoader();
    try {

      const response = await this.userManagementService.getApprovalData(
        Number(this.cookieService.get('userId')),
        '', //searchParam
        '',//sortDirection
        '', //sortField
        Number.MAX_SAFE_INTEGER, //limit
        0, //offset
        1, //isactive
        0 //isDelete
      );

      console.log('Approval Data response->', response);

      if (response && response.success) {
        if (
          response &&
          Array.isArray(response.rows) &&
          typeof response.totalRecords === 'number'
        ) {
          this.approvalData = response.rows;

          console.log('approval data->', this.approvalData);
        } else {
          console.error(
            'Invalid response structure: missing rows or rows is not an array',
            response
          );
        }
      } else {
        this.snack.open(
          'Error fetching the approvals Data. Please try again.',
          'OK',
          {
            duration: 3000,
          }
        );
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching approvals Data', error);
    } finally {
      this.fullLoaderService.hideLoader();
      this.cdr.detectChanges();
    }
    this.fullLoaderService.hideLoader();
  }
  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand;
    } else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand;
    } else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand;
    } else if (section == 'form4') {
      this.isForm4Expand = !this.isForm4Expand;
    } else if (section == 'form5') {
      this.isForm5Expand = !this.isForm5Expand;
    } else if (section == 'form6') {
      this.isForm6Expand = !this.isForm6Expand;
    } else if (section == 'form7') {
      this.isForm7Expand = !this.isForm7Expand;
    } else if (section == 'form8') {
      this.isForm8Expand = !this.isForm8Expand;
    } else if (section == 'form9') {
      this.isForm9Expand = !this.isForm9Expand;
    } else if (section == 'form10') {
      this.isForm10Expand = !this.isForm10Expand;
    } else if (section == 'form11') {
      this.isForm11Expand = !this.isForm11Expand;
    } else if (section == 'form12') {
      this.isForm12Expand = !this.isForm12Expand;
    }
  }

  async sendPOForApproval(){
    // Check if Port Agent Details is filled
    if (this.isPortAgentMissing) {
      const snackBarRef = this.snack.open(
        'Port Agent Details is required. Please fill it on the Payment Terms tab before proceeding.',
        'Go to Payment Terms',
        { duration: 5000 }
      );
      snackBarRef.onAction().subscribe(() => {
        this.goToPaymentTermsTab();
      });
      return;
    }

    this.fullLoaderService.showLoader();
    const lineItemTotal = Number(this.secondFormGroup.get('quoteLineItemTotal')?.value);

    const matchingApproval = this.approvalData.find(
      (approval) =>
        lineItemTotal >= Number(approval.limitMinimum) &&
        lineItemTotal <= Number(approval.limitMaximum)
    );

  if (matchingApproval) {
      const selectedApprovalId = matchingApproval.id;
      console.log('✅ Matched Approval ID:', selectedApprovalId);
      const emailData = {
        approvalLevel: matchingApproval.approvalLevel,
        limitMinimum: matchingApproval.limitMinimum,
        limitMaximum: matchingApproval.limitMaximum,
        approverEmails: matchingApproval.userEmails,
        approverNames: matchingApproval.userNames,
        approverUserIds: matchingApproval.selectedUserIds,
        purchaseOrderId: this.purchaseOrderId,
        poRefNumber: this.firstFormGroup.get('purchaseOrderRefNumber')?.value,
        buyerEmail: this.firstFormGroup.get('buyerEmail')?.value,
        supplierEmail: this.firstFormGroup.get('supplierEmail')?.value,
        totalAmount: lineItemTotal,
        currency: this.secondFormGroup.get('supplierCurrency')?.value,
        supplierCompanyName: this.headerResponse.supplierCompanyName,
        supplierLogo: this.supplierLogo,
        buyerLogo: this.buyerLogo,
        vesselName: this.firstFormGroup.get('vesselName')?.value,
        totalItems: this.lineItemtableForm.get('rows')?.value.length || 0,
        paymentTerms: this.paymentFormGroup.get('buyersPaymentTerms')?.value,
        deliveryDate: this.firstFormGroup.get('expectedDeliveryDate')?.value,
        rfqRefNumber: this.firstFormGroup.get('rfqRefNumber')?.value,
        quoteRefNumber: this.firstFormGroup.get('quoteRefNumber')?.value,
        buyerId: Number(this.cookieService.get('userId')) || this.headerResponse.buyerId,
        supplierId: this.headerResponse.supplierId,
        supplierCompanyEmail: this.headerResponse.supplierCompanyEmail,
      }
      console.log('email Data for sending Appproval emails->',emailData)

      this.selectedApprovalId = selectedApprovalId;

      const params = {
        section: 'mappingApprovalIdToPO',
        purchaseOrderStatus: 14,
        purchaseOrderTabId: this.selectedApprovalId, //using purchaseOrderTabId to store the approval Id in POD table
        quoteId: this.quoteId,
        userId: Number(this.cookieService.get('userId')),
        purchaseOrderId: this.purchaseOrderId,
        rfqId: this.rfqId,
        emailData: emailData
      };

     const result = await this.purchaseOrderService.updatePurchaseOrder(params);
    setTimeout(() => {
        this.router.navigate(['dashboard', 'supplier']);
      }, 3000);
    this.fullLoaderService.hideLoader();
  } else {
    // No approval level found
    console.warn("⚠️ No matching approval level found");
    this.snack.open(`For this purchase order cost, we don't have any approval.`, "OK", { duration: 3000 });
  }

  }

  sendBackToList(){
    this.router.navigate(['operations', 'purchase-order-list']);
  }
  async save(isDraft?: boolean) {
    console.log('INSIDE SAVE');

    // Check if Port Agent Details is filled (only for final submit, not for draft)
    if (!isDraft && this.isPortAgentMissing) {
      const snackBarRef = this.snack.open(
        'Port Agent Details is required. Please fill it on the Payment Terms tab before proceeding.',
        'Go to Payment Terms',
        { duration: 5000 }
      );
      snackBarRef.onAction().subscribe(() => {
        this.goToPaymentTermsTab();
      });
      return;
    }

    this.fullLoaderService.showLoader();

    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }

    const lineItemTotal = Number(this.secondFormGroup.get('quoteLineItemTotal')?.value);

    const params = {
      section: 'preview',
      purchaseOrderStatus: isDraft ? 14 : 3,
      purchaseOrderTabId: 4,
      quoteId: this.quoteId,
      userId: Number(this.cookieService.get('userId')),
      purchaseOrderId: this.purchaseOrderId,
      termsConditionsAttachment:
        this.paymentFormGroup.get('attachments')?.value,
      rfqId: this.rfqId,
    };

    const result = await this.purchaseOrderService.updatePurchaseOrder(params);
    
    if (!isDraft) {
      const poPayload = this.buildPurchaseOrderPayload();
      console.log({ poPayload });
      await this.purchaseOrderService.sendPoConfirmationForBuyerAndSupplier(
        poPayload
      );
      console.log("sent the mails");
      setTimeout(() => {
        // this.router.navigate(['dashboard', 'supplier']);
        this.router.navigate(['/operations/purchase-order-list'], {
          queryParams: { 
            selectedStatus: 'Sent',
            label: 'Order'
          }
        });
      }, 3000); // 3000 milliseconds = 3 seconds
    }else{
      this.router.navigate(['/operations/purchase-order-list'], {
        queryParams: { 
          selectedStatus: 'Draft',
          label: 'Order'
        }
      });
    }
    this.fullLoaderService.hideLoader();
  }

  isValidFreight(): boolean {
    const freightField = this.secondFormGroup.get('quoteLineItemFreight');

    // Check if freight details are provided
    if (!freightField?.value || freightField?.value.length === 0) {
      return false; // Return false if freight details are not provided
    }

    return true; // Return true if freight details are valid
  }

  async back() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params['rfqId'] != '' && params['quoteId'] != '') {
        this.rfqId = params['rfqId'];
        this.quoteId = params['quoteId'];

        this.router.navigate(['dashboard', 'quote', 'create', 'header'], {
          queryParams: { rfqId: this.rfqId, quoteId: this.quoteId },
        });
      }
    });
  }
  closeLineItems() {
    this.router.navigate(['operations', 'all-documents']);
  }
  async next() {
    // if (this.isSaved) {

    //   this.activatedRoute.queryParams.subscribe(async params => {

    //     if (params['rfqId'] != '' && params['quoteId'] != '' ) {

    //       this.rfqId = params['rfqId']
    //       this.quoteId = params['quoteId']

    //       this.router.navigate([
    //         "dashboard", "quote", "create", 'payment-terms'
    //       ],
    //         {
    //           queryParams: { rfqId: this.rfqId, quoteId:this.quoteId }
    //         }
    //       );

    //   }})

    // }

    if (this.isSaved) {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (params['rfqId'] != '' && params['quoteId'] != '') {
          this.rfqId = params['rfqId'];
          const quoteId = this.quoteId;

          this.router.navigate(['dashboard', 'quote', 'create', 'header'], {
            queryParams: { rfqId: this.rfqId, quoteId: quoteId },
          });
        }
      });
    }
    // else{
    //   this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
    // }
  }

  // async close() {}

  calculateRowValues(index: number): void {
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row);
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row
      .get('discountedUnitPrice')
      ?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary();
  }

  calculateCostSummary() {
    let subTotalCost = 0;
    let totalDiscount = 0;
    let totalUnitCost = 0;
    let totalCost = 0;
    let totalFreightAmount = 0;

    let taxPercentage = 0;
    let taxAmount = 0;

    const lineItemTable = this.lineItemtableForm.value;

    const row = lineItemTable.rows;

    row.forEach((item: any) => {
      if (item.isActive === 1) {
        const quantity = item.supplierQuantity || 0;
        const unitCost = item.unitCost || 0;
        const discount = item.discount || 0;
        const discountedUnitPrice = this.round3(item.discountedUnitPrice || 0);

        const rowTotalCost = this.round3(discountedUnitPrice * quantity);
        const rowDiscount = this.round3(unitCost * (discount / 100) * quantity);
        const rowUnitCost = this.round3(unitCost * quantity);

        subTotalCost = this.round3(subTotalCost + rowTotalCost);
        totalDiscount = this.round3(totalDiscount + rowDiscount);
        totalUnitCost = this.round3(totalUnitCost + rowUnitCost);
        totalCost = this.round3(totalCost + rowTotalCost);
      }
    });

    if (
      this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value !=
      null
    ) {
      const type = this.secondFormGroup.get(
        'quoteLineItemGeneralDiscountType'
      )?.value;

      const genDiscount = parseFloat(
        this.secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value ||
          '0'
      );

      if (type == 'percentage') {
        const dec = this.round3((genDiscount / 100) * totalCost);
        totalCost = this.round3(totalCost - dec);
      } else {
        const dec = this.round3(genDiscount);
        totalCost = this.round3(totalCost - dec);
      }
    }
    // if(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value != null){

    //   const type = this.secondFormGroup.get('quoteLineItemFreightTotal')?.value

    //   const freight = parseFloat(this.secondFormGroup.get('quoteLineItemFreight')?.value || '0');

    //   if(type == 'percentage' ){
    //     totalCost += (freight / 100) * totalCost;
    //   }
    //   else{
    //     totalCost = totalCost + freight;
    //   }
    //   }
    if (this.secondFormGroup.get('quoteLineItemFreight')?.value != null) {
      console.log('hi');
      const freight = this.secondFormGroup.get('quoteLineItemFreight')?.value;

      if (freight.length > 0) {
        freight.forEach(
          (item: { freightValue: string; freightType: string }) => {
            const freightValue = this.round3(parseFloat(item.freightValue));

            if (item.freightType === 'percentage') {
              const inc = this.round3((freightValue / 100) * totalCost);
              totalCost = this.round3(totalCost + inc); // Apply percentage freight increment
              totalFreightAmount = this.round3(totalFreightAmount + inc);
            } else if (item.freightType === 'amount') {
              totalCost = this.round3(totalCost + freightValue); // Add flat freight amount
              totalFreightAmount = this.round3(totalFreightAmount + freightValue);
            }
          }
        );
      }
    }

    if (
      this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value !=
      null
    ) {
      const selectedTaxId = this.secondFormGroup.get(
        'quoteLineItemApplicableTaxProfile'
      )?.value;

      console.log("selectedTaxId",selectedTaxId);

      const selectedTaxProfile = this.taxStatusData.find(
        (tax) => tax.taxId === Number(selectedTaxId)
      );

      if (selectedTaxProfile && selectedTaxProfile.taxPercentage) {
        taxPercentage = parseFloat(selectedTaxProfile.taxPercentage);
      }

      // Check if valid tax percentage
      if (!isNaN(taxPercentage) && taxPercentage > 0) {
        taxAmount = this.round3((subTotalCost * taxPercentage) / 100);
        totalCost = this.round3(totalCost + taxAmount);
      }
    }

    console.log(
      this.secondFormGroup.get('quoteLineItemFreightTotal')?.value,
      totalFreightAmount,
      'totalFreightAmount'
    );

    this.secondFormGroup
      .get('quoteLineItemTaxAmount')
      ?.setValue(this.round3(taxAmount), { emitEvent: false });

    this.secondFormGroup
      .get('quoteLineItemFreightTotal')
      ?.setValue(this.round3(totalFreightAmount), { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemListPriceSubtotal')
      ?.setValue(this.round3(totalUnitCost), { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemDiscount')
      ?.setValue(this.round3(totalDiscount), { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemSubtotal')
      ?.setValue(this.round3(subTotalCost), { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemTotal')
      ?.setValue(this.round3(totalCost), { emitEvent: false });
  }

  calculateTaxAmount(index: number): void {
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row);
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row
      .get('discountedUnitPrice')
      ?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary();
  }

  populateForm(data: any[]) {
    console.log(data);
    data.forEach((item) => {
      this.addRow(item);
    });
  }
  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) && // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32) // space
    ) {
      event.preventDefault();
    }
  }

  addRow(data: any) {
    // const discountedUnitPrice = this.calculateDiscountedUnitPrice(data);
    // const totalCost = this.calculateTotalCost(data, discountedUnitPrice);

    const row = this._formBuilder.group({
      id: [data.id || null],
      position: [data.position || ''],
      partNumber: [data.partNumber || ''],
      supplierPartNumber: [data.supplierPartNumber || ''],
      itemDescription: [data.itemDescription || ''],
      impaId: [data.impaId || 0],
      buyerComment: [data.buyerComment || ''],
      supplierComment: [data.supplierComment || ''],
      customsCode: [data.customsCode || ''],
      attachments: [data.attachments || []],
      uom: [data.uom || ''],
      supplierUom: [data.supplierUom || ''],
      quantity: [data.quantity || 0],
      // supplierQuantity: [data.quantity || 0],
      supplierQuantity: [data.supplierQuantity || 0],
      unitCost: [this.round3(data.price || 0.0), Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedUnitCost: [this.round3(data.price || 0.0)],
      discount: [data.discount || 0.0, Validators.pattern(/^\d+(\.\d+)?$/)],
      discountedUnitPrice: [
        this.round3(data.discountedUnitPrice || 0.0),
        Validators.pattern(/^\d+(\.\d+)?$/),
      ],
      totalCost: [this.round3(data.totalCost || 0.0), Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedTotalCost: [this.round3(data.totalCost || 0.0)],
      isActive: [data.isActive],
      declineReasonTypeId: [data.declineReasonTypeId || null],
      delineOtherReason: [data.delineOtherReason || ''],
      declineReasonDescription: [data.declineReasonDescription || ''],
      leadTime: [data.leadTime || 0],

      isNew: [data.isNew || 0],
      isAddedBySupplier: [data.isAddedBySupplier || 0],
      supplierProductId: [data.supplierProductId || 0],
      addedLineItempartNumber: [data.addedLineItempartNumber || 0],
    });

    console.log(this.lineItemtableForm.get('rows'), 'test 1');

    // this.setupRowListeners(row);
    this.rows.push(row); // Add the row to the FormArray

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  addNewLineItem() {
    const obj = {
      position: this.dataSource.length + 1,
      id: null,
      partNumber: null,
      supplierPartNumber: null,
      itemDescription: null,
      impaId: null,
      buyerComment: null,
      supplierComment: '',
      customsCode: '',
      attachments: [],
      uom: null,
      quantity: 0,
      supplierUom: null,
      supplierQuantity: 0,
      unitCost: 0,
      discount: 0,
      totalCost: 0,
      isActive: 1,
      isNew: 1,
      isAddedBySupplier: 1,
      supplierProductId: 0,
      addedLineItempartNumber: 0,
    };

    // const obj = {
    //   position: this.dataSource.length + 1,   // Increment position based on the length of dataSource
    //   id: null,
    //   partNumber: null,
    //   supplierPartNumber: null,
    //   itemDescription: null,
    //   impaId: null,
    //   buyerComment: null,
    //   supplierComment: '',
    //   customsCode: '',
    //   attachments: [],
    //   uom: null,
    //   quantity: 0,
    //   supplierUom: null,
    //   supplierQuantity: 0,
    //   price:0,
    //   discount:null,
    //   totalCost: null,
    //   isActive: true,
    //   isNew: true
    // };

    this.addRow(obj);
    this.dataSource = [...this.dataSource, obj];
    // this.dataSource = lineItemData

    console.log(this.lineItemtableForm.get('rows'), 'test 2', this.dataSource);
  }

  get rows(): FormArray {
    return this.lineItemtableForm.get('rows') as FormArray;
  }

  async prefillRfqLineItems() {
    if (this.rfqId) {
      this.fullLoaderService.showLoader();

      let params = {
        rfqId: this.rfqId,
        supplierId: Number(this.cookieService.get('userId')),
      };

      const data = await this.quoteService.fetchRfqLineItemDetails(params);

      if (data && data.length > 0) {
        this.dataSource = [];

        const lineItemData = data;

        lineItemData.forEach((item: any, index: any) => {
          const obj = {
            position: index + 1,
            id: null,
            partNumber: item.partNumber,
            supplierPartNumber: item.partNo,
            itemDescription: item.itemDescription,
            impaId: item.supplierProductId,
            buyerComment: item.buyerComments,
            supplierComment: '',
            customsCode: '',
            attachments: '',
            uom: item.uom,
            quantity: item.quantity,
            supplierUom: '',
            supplierQuantity: '',
            unitCost: item.unitCost,
            discount: item.discount,
            totalCost: item.price,
            isActive: item.isActive,
          };

          this.dataSource.push(obj);
        });
      }

      this.populateForm(this.dataSource);
      this.fullLoaderService.hideLoader();
    }
  }
  async fetchRfqDetails() {
    // this.fullLoaderService.showLoader()
    let paramsData = {
      rfqId: this.rfqId,
      supplierId: Number(this.cookieService.get('userId')),
    };
    const data = await this.quoteService.fetchRfqDetails(paramsData);
    this.headerData = data.rfqData[0];
    this.fullLoaderService.hideLoader();
  }

  async rfqActions(action: string) {
    if (action == 'download') {
      this.fullLoaderService.showLoader();

      let fileName = this.headerData?.rfqRefNumber + '.pdf';

      let data = {
        supplierId: Number(this.cookieService.get('userId')),
        rfqId: this.rfqId,
      };
      const pdf = await this.SettingsService.generateSupplierRfqAttachment(
        data
      );

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      // Create a temporary <a> element
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.fullLoaderService.hideLoader();
    } else if (action == 'decline') {
      this.showDeclineConfirmationDialogue = true;
    } else if (action == 'acknowledge') {
      this.fullLoaderService.showLoader();

      let data = {
        operation: action,
        selectedRfqId: [this.headerData.supplierRfqId],
      };

      await this.SettingsService.rfqOperations(data);
      this.fullLoaderService.hideLoader();
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });
    }
    this.fetchRfqDetails();
  }

  async selectMatTabLink(tabItem: any) {
    // await this.save();
    // if(this.showNotification)return;

    if (tabItem.route == 'header') {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (
          params['rfqId'] != '' &&
          params['quoteId'] != '' &&
          params['purchaseOrderId'] != ''
        ) {
          this.rfqId = params['rfqId'];
          this.quoteId = params['quoteId'];
          this.purchaseOrderId = params['purchaseOrderId'];

          this.router.navigate(['operations', 'createOrder', 'header'], {
            queryParams: {
              rfqId: this.rfqId,
              quoteId: this.quoteId,
              purchaseOrderId: this.purchaseOrderId,
            },
          });
        }
      });
    } else if (tabItem.route == 'payment-terms') {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (
          params['rfqId'] != '' &&
          params['quoteId'] != '' &&
          params['purchaseOrderId'] != ''
        ) {
          this.rfqId = params['rfqId'];
          this.quoteId = params['quoteId'];
          this.purchaseOrderId = params['purchaseOrderId'];

          this.router.navigate(['operations', 'createOrder', 'payment-terms'], {
            queryParams: {
              rfqId: this.rfqId,
              quoteId: this.quoteId,
              purchaseOrderId: this.purchaseOrderId,
            },
          });
        }
      });
    } else if (tabItem.route == 'line-items') {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (
          params['rfqId'] != '' &&
          params['quoteId'] != '' &&
          params['purchaseOrderId'] != ''
        ) {
          this.rfqId = params['rfqId'];
          this.quoteId = params['quoteId'];
          this.purchaseOrderId = params['purchaseOrderId'];

          this.router.navigate(['operations', 'createOrder', 'line-items'], {
            queryParams: {
              rfqId: this.rfqId,
              quoteId: this.quoteId,
              purchaseOrderId: this.purchaseOrderId,
            },
          });
        }
      });
    }
  }

  // Navigate to Payment Terms tab to fill Port Agent Details
  goToPaymentTermsTab(): void {
    this.router.navigate(['operations', 'createOrder', 'payment-terms'], {
      queryParams: {
        rfqId: this.rfqId,
        quoteId: this.quoteId,
        purchaseOrderId: this.purchaseOrderId,
      },
    });
  }

  async checkisTabEnabled() {
    // const data2 = await this.quoteService.getQuoteDraftData('tab1', this.quoteId)
    // if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0 && data2[0].rfqLineItemDetails.length > 0) {
    //   this.tabEnabled = true
    // }
  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.showCloseDialogue = true;
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
  }

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
    // setTimeout(() => {
    //   if (this.table) {
    //     this.table.recalculate();
    //   }
    // }, 100);
  }

  toggleSidebar(value: boolean, section: string, index?: number) {
    if (section == 'attachment') {
      this.showAddDocumentSection = value;
      if (index !== undefined) {
        this.selectedLineItemIndex = index;
      }
    } else if (section == 'cost') {
      this.showAddCostSection = value;
    } else if (section == 'decline') {
      if (index !== undefined) {
        const rows = this.lineItemtableForm.get('rows') as FormArray;

        const selectedRow = rows.at(index);

        if (selectedRow.value.isNew === 1) {
          rows.removeAt(index);

          console.log(
            this.lineItemtableForm.get('rows') as FormArray,
            this.dataSource,
            'removed'
          );

          this.dataSource.splice(index, 1);

          this.dataSource = [...this.dataSource];

          this.snack.open(`New line item removed.`, 'OK', { duration: 3000 });

          this.calculateCostSummary();
        } else {
          this.selectedLineItemIndex = index;
          this.showDeclineSection = value;
        }
      }
    }
  }

  fileOver(event: any) {}
  fileLeave(event: any) {}

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try {
      const rows = this.lineItemtableForm.get('rows') as FormArray;

      if (
        this.selectedAttachmentType == undefined ||
        this.selectedAttachmentType == null
      ) {
        this.snack.open('Please select the attachment type.', 'OK', {
          duration: 3000,
        });
        return;
      }

      if (
        this.selectedAttachmentType == 1 ||
        this.selectedAttachmentType == 4
      ) {
        if (
          this.hazardousDeclaration == null ||
          this.hazardousDeclaration == undefined
        ) {
          this.snack.open('Hazardous Declaration can not be empty.', 'OK', {
            duration: 3000,
          });

          return;
        }
      }

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();

      if (this.selectedLineItemIndex != null) {
        this.uploadedAttachmentsArray =
          rows.at(this.selectedLineItemIndex).get('attachments')?.value || [];

        if (this.uploadedAttachmentsArray.length > 5) {
          throw new Error('Maximum 5 files allowed for a product!');
        }

        const fileEntries = files
          .filter((entry) => entry.fileEntry.isFile)
          .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries, 'fileEntries');

        if (fileEntries.length === 0) {
          throw new Error('Please upload valid files!');
        }
        if (fileEntries.length > 5) {
          throw new Error('Maximum 5 files allowed for a product!');
        }

        await new Promise((res, rej) => {
          fileEntries.map((fileEntry) => {
            fileEntry.file(async (file) => {
              let fileExt = file.name.split('.').pop();
              if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
                // rej('Invalid filetype!');
                return;
              }

              if (file.size > this.maxFileSize) {
                throw new Error('File size must be less than 5MB!');
              }

              let uploadedAttachment: any = {
                lineItemIndex: this.selectedLineItemIndex,
                dataUrl: '',
                name: file.name,
                file: file,
                attachmentType: this.selectedAttachmentType,
                hazardousDeclaration: this.hazardousDeclaration,
              };

              await new Promise((res, rej) => {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                  uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                  res(true);
                };
                reader.readAsDataURL(file); // Read the file as a data URL
              });

              this.uploadedAttachmentsArray.push(uploadedAttachment);
              res(file);
            });
          });
        });

        rows.at(this.selectedLineItemIndex).patchValue({
          attachments: this.uploadedAttachmentsArray,
        });
        console.log(
          rows.at(this.selectedLineItemIndex).get('attachments')?.value,
          this.uploadedAttachmentsArray
        );

        this.fullLoaderService.hideLoader();
      }
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  onDeclineReasonChange(event: MatSelectChange) {
    const selectedValue = event.value;

    if (selectedValue == '7') {
      this.showOtherReason = true;
    } else {
      this.showOtherReason = false;
    }
  }

  onAttachmentTypeChange(event: MatSelectChange) {
    const selectedValue = event.value;

    if (selectedValue == 1 || selectedValue == 4) {
      this.showHazardousDeclaration = true;
    } else {
      this.showHazardousDeclaration = false;
    }
  }

  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  declineLineItem() {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    if (this.declineReason == undefined || this.declineReason == null) {
      this.snack.open('Please select the decline reason.', 'OK', {
        duration: 3000,
      });
      return;
    }

    if (
      this.declineReason == 7 &&
      (this.otherReason == null || this.otherReason == '')
    ) {
      this.snack.open('Other reason can not be empty.', 'OK', {
        duration: 3000,
      });

      return;
    }

    const reason = this.delineReasonData.find(
      (item) => item.id === this.declineReason
    );

    const reasonDesc = reason ? reason.reasonDescription : 'Reason not found';

    if (this.selectedLineItemIndex != null) {
      // const selectedRow = rows.at(this.selectedLineItemIndex);

      // if (selectedRow.value.isNew === 1) {

      //   rows.removeAt(this.selectedLineItemIndex);

      //   console.log(this.lineItemtableForm.get('rows') as FormArray,this.dataSource,'removed')

      //   this.dataSource.splice(this.selectedLineItemIndex, 1);
      //     // Trigger change detection if you're using MatTable
      //   this.dataSource = [...this.dataSource];

      //   this.snack.open(`New line item removed.`, "OK", { duration: 3000 });
      // }
      // else {

      rows.at(this.selectedLineItemIndex).patchValue({
        isActive: 0,
        declineReasonTypeId: this.declineReason,
        delineOtherReason: this.otherReason,
        declineReasonDescription: reasonDesc,
        attachments: [],
        supplierQuantity: 0,
      });

      this.snack.open(
        `Line Item Declined, selected line item attachments are removed`,
        'OK',
        { duration: 3000 }
      );
    }
    // }

    this.showDeclineSection = false;
    this.declineReason = null;
    this.otherReason = '';
    this.selectedLineItemIndex = null;

    this.calculateCostSummary();
  }

  restoreLineitem(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const quantityValue = rows.at(index).get('quantity')?.value;

    rows.at(index).patchValue({
      isActive: 1,
      declineReasonTypeId: null,
      delineOtherReason: null,
      declineReasonDescription: null,
      supplierQuantity: quantityValue || 1,
    });

    this.snack.open(`Line Item Restored`, 'OK', { duration: 3000 });

    this.calculateCostSummary();
  }

  isDecline(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const isActive = row.get('isActive')?.value;

    // Return the value (true or false)
    return isActive === 0;
  }

  getDeclineReason(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const reason = row.get('declineReasonDescription')?.value || '';

    return `Declined - ${reason || 'No reason provided'}`;
  }

  isNew(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    const isNew = row.get('isNew')?.value;

    // Return the value (true or false)
    return isNew === 1;
  }

  saveAdditionalCost() {
    if (
      this.freightDescription == '' ||
      this.freightType == '' ||
      this.freightValue == null
    ) {
      this.snack.open('Please fill the additional cost details.', 'OK', {
        duration: 3000,
      });
      return;
    }
    let params = {
      id: null,
      freightDescription: this.freightDescription,
      freightType: this.freightType,
      freightValue: this.freightValue,
      isActive: 1,
    };
    console.log('params', params);
    this.addedAdditionalCost.push(params);

    this.secondFormGroup
      .get('quoteLineItemFreight')
      ?.setValue(this.addedAdditionalCost);

    console.log(this.addedAdditionalCost);
    console.log(this.secondFormGroup);
    console.log(
      'test',
      this.secondFormGroup.get('quoteLineItemFreight')?.value
    );
    this.calculateCostSummary();

    this.showAddCostSection = false;
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
  }

  async getQuoteDraftData() {
    this.fullLoaderService.showLoader();

    // const data = await this.quoteService.getQuoteDraftData('tab2', Number(this.quoteId))
    let params = {
      purchaseOrderId: this.purchaseOrderId,
      section: 'lineItems',
    };
    const data = await this.purchaseOrderService.fetchPurchaseOrder(params);

    console.log({ data });

    if (
      data &&
      data.length > 0 &&
      Object.keys(data[0]).length > 0 &&
      data[0].quotationLineItems.length > 0
    ) {
      if (data[0].quotationLineItems[0].quoteLineItemDetailsId) {
        this.isSaved = true;
      }

      this.secondFormGroup.patchValue({
        quoteLineItemHeaderId: data[0].quoteLineItemHeaderId || '',
        quoteLineItemListPriceSubtotal: data[0].lineItemListPriceSubtotal || '',
        quoteLineItemDiscount: data[0].lineItemDiscount || '',
        quoteLineItemSubtotal: data[0].lineItemSubtotal || '',
        quoteLineItemGeneralDiscountType:
          data[0].generalDiscountType || 'percentage',
        quoteLineItemGeneralDiscountValue: data[0].generalDiscountValue || '',
        quoteLineItemFreightTotal: data[0].lineItemFreightTotal || '',
        quoteLineItemFreight: data[0].quoteLineItemFreight || '',
        quoteLineItemTotal: data[0].lineItemTotal || '',
        supplierCurrency: data[0].currency,
        quoteLineItemApplicableTaxProfile:
          data[0].lineItemApplicableTaxProfile || null,
        quoteLineItemTaxAmount: data[0].lineItemTaxAmount || 0,
      });

      console.log(
        'lineitmefreight',
        this.secondFormGroup.get('quoteLineItemFreight')?.value
      );

      this.dataSource = [];

      if (data[0].quotationLineItems && data[0].quotationLineItems.length > 0) {
        data[0].quotationLineItems.forEach(
          (
            item: {
              supplierProductId: any;
              isAddedBySupplier: any;
              leadTime: any;
              attachments: any;
              declineReasonTypeId: any;
              declineReasonDescription: any;
              delineOtherReason: any;
              supplierQuantity: any;
              supplierUom: any;
              uom: any;
              customsCode: any;
              buyerComment: any;
              impaId: any;
              supplierPartNumber: any;
              quoteLineItemDetailsId: any;
              isActive: any;
              partNumber: any;
              itemDescription: any;
              unitCost: any;
              discount: any;
              supplierComment: any;
              quantity: any;
              discountedUnitPrice: any;
              totalCost: any;
            },
            index: number
          ) => {
            const obj = {
              position: index + 1, // Assign position based on index
              id: item.quoteLineItemDetailsId,
              partNumber: item.partNumber,
              supplierPartNumber: item.supplierPartNumber,
              itemDescription: item.itemDescription,
              impaId: item.impaId,
              buyerComment: item.buyerComment,
              supplierComment: item.supplierComment,
              customsCode: item.customsCode,
              uom: item.uom,
              supplierUom: item.supplierUom,
              quantity: item.quantity,
              supplierQuantity: item.supplierQuantity,
              price: item.unitCost,
              discount: item.discount,
              discountedUnitPrice: item.discountedUnitPrice,
              totalCost: item.totalCost,
              isActive: item.isActive,
              declineReasonTypeId: item.declineReasonTypeId,
              delineOtherReason: item.delineOtherReason,
              declineReasonDescription: item.declineReasonDescription,
              attachments: item.attachments,
              leadTime: item.leadTime,
              isNew: 0,
              isAddedBySupplier: item.isAddedBySupplier,
              supplierProductId: item.supplierProductId,
            };

            this.dataSource.push(obj); // Push each object to dataSource
          }
        );

        this.populateForm(this.dataSource);
        // this.toggleSelectAllLineItem(true)
      }

      this.fullLoaderService.hideLoader();
    } else {
      this.prefillRfqLineItems();
      this.fetchDefaultCurrency();
    }

    this.fullLoaderService.hideLoader();
  }

  // Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

  // Function to display the notification with missing fields
  showMissingFieldsNotification(
    missingFields: { section: string; fields: string[] }[]
  ) {
    let message =
      '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

    // Loop through each section and list its missing fields
    missingFields.forEach((missingField) => {
      message += `<strong>${missingField.section}:</strong><br>`; // Add section name
      message += missingField.fields
        .map((field) => `  • ${field}`)
        .join('<br>'); // List missing fields with bullet points
      message += '<br><br>'; // Add extra spacing between sections
    });

    this.notificationMessage = message;
    this.notificationTitle = 'Missing Fields';
    this.notificationType = 'error'; // Change this to 'info' for informational notifications
    this.showNotification = true; // Display the notification
  }

  // // Validation logic to check for required fields
  // isValidRequiredFields(): { section: string, fields: string[] }[] {
  //   console.log("isValidRequiredFields called")
  //   const missingFields: { section: string, fields: string[] }[] = [];

  //   // Check for missing fields in Tab1 (Line Items Section)
  //   const lineItemMissingFields: string[] = [];
  //   // const lineItems = this.secondFormGroup.value;
  //   const lineItems = this.lineItemtableForm.value.rows
  //   console.log({lineItems});
  //   if (!lineItems.unitCost || lineItems.unitCost <= 0) {
  //     lineItemMissingFields.push('Unit Cost for line item');
  //   }
  //   if (!lineItems.leadTime || lineItems.leadTime <= 0) {
  //     lineItemMissingFields.push('Lead Time for line item');
  //   }

  //   if (lineItemMissingFields.length > 0) {
  //     missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  //   }

  //   // Show notification if there are missing fields
  //   if (missingFields.length > 0) {
  //     this.showMissingFieldsNotification(missingFields);
  //   }

  //   return missingFields;
  // }

  isValidRequiredFields(): { section: string; fields: string[] }[] {
    const missingFields: { section: string; fields: string[] }[] = [];

    // ✅ Check for missing fields in Tab1 (Line Items Section)
    const lineItemMissingFields: string[] = [];
    const lineItems = this.lineItemtableForm.value?.rows || [];

    lineItems.forEach((item: any, index: number) => {
      if (!item.unitCost || item.unitCost <= 0) {
        lineItemMissingFields.push(`Unit Cost for line item #${index + 1}`);
      }
      if (!item.leadTime || item.leadTime <= 0) {
        lineItemMissingFields.push(`Lead Time for line item #${index + 1}`);
      }
    });
    const form = this.secondFormGroup;

    if (!form.get('supplierCurrency')?.value) {
      lineItemMissingFields.push('Preferred Currency');
    }

    if (lineItemMissingFields.length > 0) {
      missingFields.push({
        section: 'Line Items',
        fields: lineItemMissingFields,
      });
    }

    // Show notification if there are missing fields
    if (missingFields.length > 0) {
      this.showMissingFieldsNotification(missingFields);
    }

    return missingFields;
  }

  getLineItemAttachment() {
    const rows = this.lineItemtableForm.value.rows;

    if (this.selectedLineItemIndex != null) {
      const row = rows[this.selectedLineItemIndex];
      const attachment = row.attachments || [];
      // Get the value of the 'isActive' field
      return attachment;
    } else {
      return [];
    }
  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.SettingsService.getAllCurrenciesByFliterKeyValue(
      pageMeta.serachParam,
      pageMeta
    );
  }

  getCurrencyControl(): any {
    return this.secondFormGroup.get('supplierCurrency') as FormControl;
  }

  onPartNumberSelected(event: any, index: number) {
    console.log(event, 'event');

    const selectedItem = event;

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    rows.at(index).patchValue({
      partNumber: selectedItem.partNo,
      supplierPartNumber: selectedItem.partNo,
      itemDescription: selectedItem.ItemName,
      impaId: selectedItem.impaId,
      supplierProductId: selectedItem.supplierProductId,
      quantity: 1,
      supplierQuantity: 1,
      isNew: 1,
      isAddedBySupplier: 1,
    });
  }
  // Category autocomplete section
  filterFieldSupplierProductNameDisplayFn(
    _supplierProduct: AutoCompleteSupplierProduct
  ) {
    return _supplierProduct ? `${_supplierProduct.partNo}` : undefined;
  }

  getSupplierProductFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    console.log('Search Parameter:', pageMeta.serachParam);
    const response =
      this.SettingsService.getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierId(
        pageMeta.serachParam,
        Number(this.CookieService.get('userId')),
        pageMeta
      );
    console.log('Response Category', response);
    return response;
  }

  getPartNumberControl(index: number): FormControl {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index) as FormGroup;
    return row.get('addedLineItempartNumber') as FormControl;
  }

  async getTaxDetails() {
    this.fullLoaderService.showLoader();
    let data = {
      supplierId: Number(this.cookieService.get('userId')),
    };
    const response = await this.SettingsService.getTaxDetailsBySupplier(data);
    console.log('tax details', response);
    this.taxStatusData = response.rows;
    this.fullLoaderService.hideLoader();
  }

  async fetchDefaultCurrency() {
    const transactionSetupdata = await this.SettingsService.fetchSupplierSetup(
      'TransactionSetup',
      Number(this.CookieService.get('userId'))
    );

    if (transactionSetupdata.length > 0) {
      this.secondFormGroup.patchValue({
        supplierCurrency: {
          id: transactionSetupdata[0].default_currency,
          currencyName: transactionSetupdata[0].currencyName,
          currencyCode: transactionSetupdata[0].currencyCode,
          currencySymbol: transactionSetupdata[0].currencySymbol,
        },
      });
    }
  }

  //   async togglePreview(value:boolean,section:string,docs?:any){
  //     this.previewSection=value;
  //     this.previewDocs = []
  //     if(docs){
  //       if(section == 'single'){
  //          this.previewDocs.push(docs)
  //       }
  //       else if(section == 'multiple'){
  //         this.previewDocs = docs
  //       }
  //     }
  //   }

  //   nextSlide() {
  //     this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
  //   }

  //   prevSlide() {
  //     this.currentIndex =
  //       (this.currentIndex - 1 + this.previewDocs.length) %
  //       this.previewDocs.length;
  //   }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDoc.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDoc.length) % this.previewDoc.length;
  }

  async togglePreview(value: boolean, section: string, index?: number) {
    this.currentIndex = 0;

    if (value) {
      if (section == 'generalAttachment') {
        if (value) {
          this.previewDoc = this.uploadedAdditionalAttachmentsArray;

          console.log('previewDoc', this.previewDoc);
        } else {
          this.previewDoc = [];
        }
      }
    } else {
      this.previewDoc = [];
    }

    this.previewSection = value;
  }

  getHeaderAttachmentCount(): any {
    return this.uploadedAdditionalAttachmentsArray.length;
  }

  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {
      this.fullLoaderService.showLoader();
      this.uploadedAdditionalAttachmentsArray =
        this.paymentFormGroup.get('attachments')?.value || [];

      if (this.uploadedAdditionalAttachmentsArray.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

      console.log(fileEntries, 'fileEntries');

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async (file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!');
            }

            let uploadedAttachment: any = {
              dataUrl: '',
              name: file.name,
              file: file,
            };

            await new Promise((res, rej) => {
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true);
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            });

            this.uploadedAdditionalAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      this.paymentFormGroup
        .get('attachments')
        ?.setValue(this.uploadedAdditionalAttachmentsArray);
      this.fullLoaderService.hideLoader();
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  openFileSelector() {}

  async submit(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.showCloseDialogue = true;
    }
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }

  // Optional: You can implement logic to show more info when the info icon is clicked.
  showInfo(): void {
    // Logic to show additional info (e.g., a dialog, alert, or modal)
    console.log('Info icon clicked - show additional info!');
  }

  // Safely format freight fields that may arrive as arrays, JSON strings, or plain strings
  private formatFreightField(value: any, key: string): string {
    if (value === null || value === undefined) {
      return '';
    }

    // If value is a stringified JSON array, parse it
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if ((trimmed.startsWith('[') && trimmed.endsWith(']')) ||
          (trimmed.startsWith('"[') && trimmed.endsWith(']"'))) {
        try {
          // Remove wrapping quotes if present then parse
          const toParse = trimmed.startsWith('"') && trimmed.endsWith('"')
            ? trimmed.slice(1, -1)
            : trimmed;
          value = JSON.parse(toParse);
        } catch {
          // If parsing fails, fall through and return the original string
        }
      }
    }

    // If it's an array, normalize objects or primitives
    if (Array.isArray(value)) {
      const items = value
        .map((v: any) => (v && typeof v === 'object' && key in v ? v[key] : v))
        .filter((v: any) => v !== null && v !== undefined && String(v).trim() !== '');
      return items.map((v: any) => String(v)).join(', ');
    }

    // Fallback for plain strings or other primitives
    return String(value || '');
  }

  // getPartNumberControl(index: number): FormControl {
  //   const rows = this.lineItemtableForm.get('rows') as FormArray;
  //   const row = rows.at(index) as FormGroup;
  //   // Ensure that the control handles both numbers and strings
  //   return row?.get('addedLineItempartNumber') as FormControl ?? new FormControl('');
  // }

  //  async generateAndSendPdf(): Promise<void> {
  //        if (!this.contentToPrint?.nativeElement) {
  //          console.error('PDF content element not found!');
  //          return;
  //        }

  //        // Expand all forms
  //        this.isForm1Expand = true;
  //        this.isForm2Expand = true;
  //        this.isForm3Expand = true;
  //        this.isForm4Expand = true;
  //        this.isForm5Expand = true;
  //        this.isForm6Expand = true;
  //        this.isForm7Expand = true;
  //        this.isForm8Expand = true;
  //        this.isWrapDescription = true;

  //        const element = this.contentToPrint.nativeElement;
  //        const pdf = new jsPDF('p', 'mm', 'a4');
  //        const pageWidth = pdf.internal.pageSize.getWidth() - 20; // with margins
  //        const pageHeight = pdf.internal.pageSize.getHeight() - 20;

  //        // Store original styles
  //        const originalOverflow = element.style.overflow;
  //        const originalHeight = element.style.height;

  //        try {
  //          // Temporarily modify styles for proper capture
  //          element.style.overflow = 'visible';
  //          element.style.height = 'auto';

  //          // Wait for UI to update after expanding forms
  //          await new Promise(resolve => setTimeout(resolve, 500));

  //          // Get full content dimensions
  //          const fullHeight = element.scrollHeight;

  //          // Create options for html2canvas
  //          const options = {
  //            scale: 1,
  //            useCORS: true,
  //            allowTaint: true,
  //            scrollX: 0,
  //            scrollY: 0,
  //            width: element.scrollWidth,
  //            height: fullHeight,
  //            windowWidth: element.scrollWidth,
  //            windowHeight: fullHeight,
  //            logging: true
  //          };

  //          // Capture entire content
  //          const canvas = await html2canvas(element, options);

  //          const imgWidth = pageWidth;
  //          const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //          // Split across pages if content is taller than one page
  //          let position = 0;

  //          while (position < imgHeight) {
  //            const sectionHeight = Math.min(pageHeight, imgHeight - position);

  //            if (position > 0) {
  //              pdf.addPage();
  //            }

  //            // Create a new canvas for each page section
  //            const tempCanvas = document.createElement('canvas');
  //            tempCanvas.width = canvas.width;
  //            tempCanvas.height = sectionHeight * (canvas.height / imgHeight);
  //            const ctx = tempCanvas.getContext('2d');

  //            if (ctx) {
  //              ctx.drawImage(
  //                canvas,
  //                0, // source x
  //                position * (canvas.height / imgHeight), // source y
  //                canvas.width, // source width
  //                sectionHeight * (canvas.height / imgHeight), // source height
  //                0, // destination x
  //                0, // destination y
  //                canvas.width, // destination width
  //                sectionHeight * (canvas.height / imgHeight) // destination height
  //              );

  //              const imgData = tempCanvas.toDataURL('image/jpeg');
  //              pdf.addImage(
  //                imgData,
  //                'JPEG',
  //                10, // x
  //                10, // y
  //                imgWidth,
  //                sectionHeight
  //              );
  //            }

  //            position += sectionHeight;
  //          }

  //          const pdfBlob = pdf.output('blob');

  //          // code to compress the pdf
  //        //  const arrayBuffer =  await pdfBlob.arrayBuffer();
  //        //  const buffer = Array.from(new Uint8Array(arrayBuffer));
  //        //  console.log(arrayBuffer,'arraynuffer',buffer)

  //        //   let formData = {
  //        //     bufferFile: buffer,
  //        //     rfqRefNumber: this.firstFormGroup.get('rfqRefNo')?.value,
  //        //     rfqId: Number(this.rfqId)
  //        //   }

  //        //   console.log(formData,'formData')

  //        //   await this.RfqGenerateFormService.uploadRfqAttachment(formData)
  //          // Convert canvas to blob
  //          // const blob = await new Promise<Blob>(resolve => {
  //          //   canvas.toBlob(blob => {
  //          //     if (blob) {
  //          //       resolve(blob);
  //          //     } else {
  //          //       throw new Error('Canvas to Blob conversion failed');
  //          //     }
  //          //   }, 'application/pdf');
  //          // });

  //      let s3Location = `rfq/${this.firstFormGroup.get('rfqRefNo')?.value}.pdf`

  //      let _s3Params = {
  //        fileKey: s3Location,
  //        fileContentType: pdfBlob.type || 'application/pdf',
  //      };

  //      await this.awsSdkService
  //        .getSignedUrlPromise(_s3Params)
  //        .then((_fileUploadLink: any) => {
  //          if (_fileUploadLink) {
  //            this.webApiService
  //              .putRequestExternalApi(_fileUploadLink, pdfBlob)
  //              .then(async (_fileUploadData: any) => {
  //                // //!Logic for saving file url in the database
  //                let filePath =
  //                  this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink);

  //                  let formdata = {
  //                    filePath: this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink),
  //                    rfqId:Number(this.rfqId)
  //                  }

  //                   await this.RfqGenerateFormService.sendRfq(formdata)

  //                  await this.RfqGenerateFormService.sendRfqAcknowledgment(formdata)

  //              })
  //              .catch((_httpErrorResponse: HttpErrorResponse) => {
  //                console.log(
  //                  'Error while uploading file==>',
  //                  _httpErrorResponse
  //                );
  //                this.fullLoaderService.hideLoader();
  //                // Should use ngZone.run() if we are calling the snack bar in async callbacks
  //                // this.ngZone.run(() => {
  //                //   this.snack.open(
  //                //     `${_httpErrorResponse.error.errors[0].message}`,
  //                //     'OK',
  //                //     {
  //                //       duration: 3000,
  //                //     }
  //                //   );
  //                // });
  //              });
  //          }
  //        })
  //        .catch((_httpErrorResponse: HttpErrorResponse) => {
  //          console.log(
  //            'Error while generating presigned url for file==>',
  //            _httpErrorResponse
  //          );
  //          this.fullLoaderService.hideLoader();
  //          // Should use ngZone.run() if we are calling the snack bar in async callbacks
  //          // this.ngZone.run(() => {
  //          //   this.snack.open(
  //          //     `${_httpErrorResponse.error.errors[0].message}`,
  //          //     'OK',
  //          //     {
  //          //       duration: 3000,
  //          //     }
  //          //   );
  //          // });
  //        });

  //        } catch (error) {
  //          console.error('Error generating or sending PDF:', error);
  //          throw error; // Re-throw if you want calling code to handle it
  //        } finally {
  //          // Restore original styles
  //          element.style.overflow = originalOverflow;
  //        element.style.height = originalHeight;
  //      }
  //    }

  // Generates a Purchase Order PDF from #pdfContent and uploads to S3
  // async generateAndSendPOPDf(): Promise<void> {
  //   if (!this.contentToPrint?.nativeElement) {
  //     console.error('PDF content element not found!');
  //     return;
  //   }

  //   const initialPayload = this.buildPurchaseOrderPayload();
  //   console.log('PO payload (pre-upload):', initialPayload);

  //   // Ensure all sections are expanded so the full document is captured
  //   this.isForm1Expand = true;
  //   this.isForm2Expand = true;
  //   this.isForm3Expand = true;
  //   this.isForm4Expand = true;
  //   this.isForm5Expand = true;
  //   this.isForm6Expand = true;
  //   this.isForm7Expand = true;
  //   this.isForm8Expand = true;
  //   this.isForm9Expand = true;
  //   this.isForm10Expand = true;
  //   this.isForm11Expand = true;
  //   this.isWrapDescription = true;

  //   const element = this.contentToPrint.nativeElement;
  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const pageWidth = pdf.internal.pageSize.getWidth() - 20; // margins
  //   const pageHeight = pdf.internal.pageSize.getHeight() - 20;

  //   // Store original styles
  //   const originalOverflow = element.style.overflow;
  //   const originalHeight = element.style.height;

  //   try {
  //     // Temporarily relax layout constraints
  //     element.style.overflow = 'visible';
  //     element.style.height = 'auto';

  //     // Let Angular render updates
  //     await new Promise(resolve => setTimeout(resolve, 500));

  //     const fullHeight = element.scrollHeight;

  //     const options = {
  //       scale: 1,
  //       useCORS: true,
  //       allowTaint: true,
  //       scrollX: 0,
  //       scrollY: 0,
  //       width: element.scrollWidth,
  //       height: fullHeight,
  //       windowWidth: element.scrollWidth,
  //       windowHeight: fullHeight,
  //       logging: false
  //     } as const;

  //     const canvas = await html2canvas(element, options);

  //     const imgWidth = pageWidth;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     let position = 0;
  //     while (position < imgHeight) {
  //       const sectionHeight = Math.min(pageHeight, imgHeight - position);
  //       if (position > 0) pdf.addPage();

  //       const tempCanvas = document.createElement('canvas');
  //       tempCanvas.width = canvas.width;
  //       tempCanvas.height = sectionHeight * (canvas.height / imgHeight);
  //       const ctx = tempCanvas.getContext('2d');

  //       if (ctx) {
  //         ctx.drawImage(
  //           canvas,
  //           0,
  //           position * (canvas.height / imgHeight),
  //           canvas.width,
  //           sectionHeight * (canvas.height / imgHeight),
  //           0,
  //           0,
  //           canvas.width,
  //           sectionHeight * (canvas.height / imgHeight)
  //         );

  //         const imgData = tempCanvas.toDataURL('image/jpeg');
  //         pdf.addImage(imgData, 'JPEG', 10, 10, imgWidth, sectionHeight);
  //       }

  //       position += sectionHeight;
  //     }

  //     const pdfBlob = pdf.output('blob');

  //     // Build S3 key using PO reference
  //     const poRef = this.firstFormGroup.get('purchaseOrderRefNumber')?.value || `po-${Date.now()}`;
  //     const s3Location = `purchase-order/${poRef}.pdf`;

  //     const _s3Params = {
  //       fileKey: s3Location,
  //       fileContentType: pdfBlob.type || 'application/pdf',
  //     };

  //     await this.awsSdkService
  //       .getSignedUrlPromise(_s3Params)
  //       .then((_fileUploadLink: any) => {
  //         if (_fileUploadLink) {
  //           this.webApiService
  //             .putRequestExternalApi(_fileUploadLink, pdfBlob)
  //             .then(async () => {
  //               const filePath = this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink);
  //               let formdata = {
  //                  filePath: this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink),
  //                  rfqId:Number(this.rfqId)
  //                }

  //                 console.log('PO PDF uploaded to S3 at:', filePath);

  //               // await this.RfqGenerateFormService.sendRfqAcknowledgment(formdata)
  //               const poPayload = this.buildPurchaseOrderPayload(filePath);
  //               console.log('PO payload (final with PDF path):', poPayload);
  //              // await this.purchaseOrderService.sendPoConfirmationForBuyerAndSupplier(poPayload);
  //               // Optional: persist filePath with PO using purchaseOrderService if needed
  //               console.log('PO PDF generated and uploaded.');
  //             })
  //             .catch((err: HttpErrorResponse) => {
  //               console.error('Error while uploading PO PDF:', err);
  //               this.fullLoaderService.hideLoader();
  //             });
  //         }
  //       })
  //       .catch((err: HttpErrorResponse) => {
  //         console.error('Error generating presigned url for PO PDF:', err);
  //         this.fullLoaderService.hideLoader();
  //       });

  //   } catch (error) {
  //     console.error('Error generating or sending PO PDF:', error);
  //     throw error;
  //   } finally {
  //     element.style.overflow = originalOverflow;
  //     element.style.height = originalHeight;
  //   }
  // }

  private buildPurchaseOrderPayload(poPdfPath?: string): any {
    const header = this.firstFormGroup?.value || {};
    const payment = this.paymentFormGroup?.value || {};
    const pricing = this.secondFormGroup?.value || {};

    const lineItemsFormArray =
      (this.lineItemtableForm?.get('rows') as FormArray) ||
      this._formBuilder.array([]);
    const lineItems = lineItemsFormArray.controls
      .map((ctrl: any) => ctrl.value)
      .map((li: any, idx: number) => ({
        position: li.position ?? idx + 1,
        id: li.id ?? null,
        partNumber: li.partNumber ?? null,
        supplierPartNumber: li.supplierPartNumber ?? null,
        itemDescription: li.itemDescription ?? null,
        impaId: li.impaId ?? null,
        buyerComment: li.buyerComment ?? null,
        supplierComment: li.supplierComment ?? null,
        customsCode: li.customsCode ?? null,
        uom: li.uom ?? null,
        supplierUom: li.supplierUom ?? null,
        requestedQuantity: li.quantity ?? 0,
        supplierQuantity: li.supplierQuantity ?? 0,
        unitCost: this.round3(li.unitCost ?? 0),
        requestedUnitCost: this.round3(li.requestedUnitCost ?? li.unitCost ?? 0),
        discount: this.round3(li.discount ?? 0),
        discountedUnitPrice: this.round3(li.discountedUnitPrice ?? 0),
        totalCost: this.round3(li.totalCost ?? 0),
        requestedTotalCost: this.round3(li.requestedTotalCost ?? li.totalCost ?? 0),
        leadTime: li.leadTime ?? 0,
        isActive: li.isActive ?? 1,
        declineReasonTypeId: li.declineReasonTypeId ?? null,
        declineReasonDescription: li.declineReasonDescription ?? null,
        declineOtherReason: li.delineOtherReason ?? null,
        isNew: li.isNew ?? 0,
        isAddedBySupplier: li.isAddedBySupplier ?? 0,
        supplierProductId: li.supplierProductId ?? 0,
        attachments: (li.attachments || []).map((a: any) => ({
          name: a.name ?? null,
          systemName: a.systemName ?? null,
          fileKey: a.fileKey ?? null,
          s3_path: a.s3_path ?? null,
        })),
      }));

    const termsAttachments = (
      this.uploadedAdditionalAttachmentsArray || []
    ).map((f: any) => ({
      name: f.name ?? null,
      size: f.file?.size ?? null,
      mimeType: f.file?.type ?? null,
    }));

    const poDetails = {
      purchaseOrderRefNumber: header.purchaseOrderRefNumber || null,
      purchaseOrderDate: header.purchaseOrderDate || null,
      rfqRefNumber: header.rfqRefNumber || null,
      rfqDate: header.rfqDate || null,
      quoteRefNumber: header.quoteRefNumber || null,
      quotationDate: header.quotationDate || null,
      expectedDeliveryDate: header.expectedDeliveryDate || null,
    };

    const buyer = {
      company: {
        name: header.buyerName || null,
        email: header.buyerEmail || null,
        phone: header.buyerPhone || null,
        fax: header.buyerFax || null,
        address: header.buyerAddress || null,
        logo: this.buyerLogo || null,
      },
      contact: {
        person: header.buyerContactPerson || null,
        email: header.buyerContactEmail || null,
        phone: header.buyerContactPhone || null,
        fax: header.buyerContactFax || null,
        address: header.buyerContactAddress || null,
      },
    };
    const supplierDetails = {
      company: {
        name: this.headerResponse.supplierCompanyName || null,
        email: this.headerResponse.supplierCompanyEmail || null,
        phone: this.headerResponse.supplierPhone || null,
        fax: this.headerResponse.supplierFax || null,
        address: this.headerResponse.supplierAddress || null,
        logo: this.supplierLogo || null,
      },
      contact: {
        id: Number(this.supplierId) || null,
        contactName: header.supplierContactName || null,
        email: header.supplierEmail || null,
        phone: header.supplierPhone || null,
        fax: header.supplierFax || null,
      },
    };

    // const supplier = {
    //   id: Number(this.supplierId) || null,
    //   contactName: header.supplierContactName || null,
    //   email: header.supplierEmail || null,
    //   phone: header.supplierPhone || null,
    //   fax: header.supplierFax || null,
    //   companyEmail: header.supplierCompanyEmail || null,
    //   logo: this.supplierLogo || null,
    // };

    const vessel = {
      name: header.vesselName || null,
      imoNumber: header.vesselIMONumber || null,
      type: header.vesselType || null,
      class: header.vesselClass || null,
    };

    const port = {
      name: this.headerResponse.portName || null,
      code: this.headerResponse.portCode || null,
      eta: this.headerResponse.vesselEta || null,
      etd: this.headerResponse.vesselEtd || null,
    };

    const portAgent = {
      portAgencyName: this.portAgencyAndFreightAndBillingResponse.portAgencyName || null,
      name: this.portAgencyAndFreightAndBillingResponse.portAgentName || null,
      phoneNumber: this.portAgencyAndFreightAndBillingResponse.portAgentPhoneNumber || null,
      contact: this.portAgencyAndFreightAndBillingResponse.portAgentContact || null,
      phoneFax: this.portAgencyAndFreightAndBillingResponse.portAgentPhoneFax || null,
      email: this.portAgencyAndFreightAndBillingResponse.emailId || null,
      address: this.portAgencyAndFreightAndBillingResponse.portAgentAddress || null,
    };

    const freightForwarder = {
      companyName: this.portAgencyAndFreightAndBillingResponse.freightCompanyName || null,
      pic: this.portAgencyAndFreightAndBillingResponse.freightPIC || null,
      jobTitle: this.portAgencyAndFreightAndBillingResponse.freightJobTitle || null,
      email: this.portAgencyAndFreightAndBillingResponse.freightEmail || null,
      phone: this.portAgencyAndFreightAndBillingResponse.freightPhone || null,
      fax: this.portAgencyAndFreightAndBillingResponse.freightFax || null,
      address: this.portAgencyAndFreightAndBillingResponse.freightAddress || null,
      packaging: this.portAgencyAndFreightAndBillingResponse.freightPackaging || null,
      transportMode: this.portAgencyAndFreightAndBillingResponse.freightTransportMode || null,
    };

    const incotermDetails = {
      incotermId: null,
      incotermCode: this.incotermsCode || null,
      locations: this.incotermLocations || '',
    };

    const priceDetails = {
      currency: pricing.supplierCurrency || null,
      listPriceSubtotal: this.round3(pricing.quoteLineItemListPriceSubtotal ?? 0),
      discount: this.round3(pricing.quoteLineItemDiscount ?? 0),
      subtotal: this.round3(pricing.quoteLineItemSubtotal ?? 0),
      generalDiscount: {
        type: pricing.quoteLineItemGeneralDiscountType || 'percentage',
        value: this.round3(pricing.quoteLineItemGeneralDiscountValue ?? 0),
      },
      freight: (pricing.quoteLineItemFreight || []).map((f: any) => ({
        id: f.id ?? null,
        description: f.freightDescription ?? null,
        type: f.freightType ?? 'amount',
        value: this.round3(Number(f.freightValue ?? 0)),
        isActive: f.isActive ?? 1,
      })),
      freightTotal: this.round3(pricing.quoteLineItemFreightTotal ?? 0),
      applicableTaxProfile: pricing.quoteLineItemApplicableTaxProfile ?? null,
      taxAmount: this.round3(pricing.quoteLineItemTaxAmount ?? 0),
      total: this.round3(pricing.quoteLineItemTotal ?? 0),
    };
    const taxDetails={

      vat:this.headerResponse.taxNumber,
    }

    const termsAndConditions = {
      billingAddress: this.portAgencyAndFreightAndBillingResponse.billingAddress || null,
      applicableTaxProfile: this.portAgencyAndFreightAndBillingResponse.applicableTaxProfile || null,
      buyersPaymentTerms: this.portAgencyAndFreightAndBillingResponse.buyersPaymentTerms || null,
      text: payment.termsAndConditions || null,
      attachments: termsAttachments,
    };

    return {
      ids: {
        purchaseOrderId: this.purchaseOrderId ?? null,
        rfqId: this.rfqId ?? null,
        quoteId: this.quoteId ?? null,
      },
      purchaseOrder: poDetails,
      buyer,
      // supplier,
      supplierDetails,
      vessel,
      port,
      portAgent,
      freightForwarder,
      incotermDetails,
      priceDetails,
      termsAndConditions,
      lineItems,
      taxDetails,
      documents: {
        poPdfPath: poPdfPath || null,
      },
    };
  }
}
